import i18next from 'i18next';
import { getPathWithoutLanguageCode } from '~utils/languageInURL/getPathWithoutLanguageCode';
export var getPathWithLanguageCode = function (path) {
    var _a;
    var currentLang = (_a = i18next.language) !== null && _a !== void 0 ? _a : 'de';
    var pathWithoutLanguageCode = getPathWithoutLanguageCode(path);
    return "/".concat(currentLang).concat('', pathWithoutLanguageCode);
};
